<div class="w-full search-container d-flex fl-al-center fl-justify-between" [ngClass]="{ 'p-0': isInputFullWidth, 'pr-0': isbalanceSheetOwner }">
  <div class="form-group form-main form-group-overrides width-100per mb-0">
    <div class="div-group width-100per">
      @if (selectedConfiguration && selectedConfigurationElement && filterConfiguration && filterConfiguration.length) {
      <mat-form-field
        id="access-manager-matAutoComplete"
        matTooltipClass="add-member-tooltip"
        [ngClass]="{
          'disable-search': disableSearch,
          'white-background': isInputFocused,
          'temp-alignment': !isInputFocused,
          'w-full': isInputFullWidth,
          'max-w-full': isInputFullWidth,
        }"
      >
        <div matPrefix class="mr-2 matPrefix-search-icon flex-center">
          <img src="../../../../assets/images/search-blue.svg" width="20px" height="19px" />
        </div>

        <input
          #inputField
          type="text"
          matInput
          aria-label="Number"
          [disabled]="disableSearch"
          [formControl]="connectionUserFormControl"
          [matAutocomplete]="auto"
          (input)="onMemberSearch($event.target.value)"
          [placeholder]="placeHolder ?? selectedConfiguration.placeHolder"
          class="addMember global-input text-base font-sans font-normal"
          [ngClass]="{ 'text-[#53565B66]': disableSearch }"
          (focus)="onInputFocus()"
          (blur)="onInputBlur()"
        />

        @if (connectionUserFormControl.value && !isComboInput) {
        <div matSuffix (click)="onClearInput()">
          <mat-icon class="close-input-icon mr-4">close</mat-icon>
        </div>
        } @if (isInputFocused && isComboInput) {
        <div matSuffix (click)="onClearInput()">
          <mat-icon class="close-input-icon mr-4">close</mat-icon>
        </div>
        }

        <mat-autocomplete
          #auto="matAutocomplete"
          class="search-scroll-main template-Search manage__combo--tab--group"
          (opened)="forceAutocompletePanelToOpenBelow()"
          (closed)="onPanelClosed()"
        >
          @if (unifiedView && isInputFocused) {
          <div class="width-100per">
            @if ((mergedData | filterUnifiedDataList : filterConfiguration : connectionUserFormControl.value)?.length === 0) {
            <mat-option class="h-fit">
              <div class="flex gap-4 py-5 h-fit fl-al-center">
                <div class="flex" style="height: 84px; width: 84px">
                  <img src="assets/images/no-matchin-result.svg" />
                </div>
                <div class="app__form--attribute--title font-normal text-sm text-[#18191C]">
                  <div class="font-semibold text-[22px] leading-6 mb-2">No matching results to show</div>
                  <div>Try changing the search terms, or add a new template</div>
                </div>
              </div>
            </mat-option>
            } @if ((mergedData | filterUnifiedDataList : filterConfiguration : connectionUserFormControl.value)?.length > 0) {
            <div class="search-list-overflow p-0">
              @for (item of mergedData | filterUnifiedDataList : filterConfiguration : connectionUserFormControl.value; track item.id) {
              <mat-option class="search-list-box unified-view-option" (onSelectionChange)="selectUnifiedItem(item)">
                <div class="d-flex fl-justify-between fl-al-center">
                  <div class="d-flex fl-al-center gap-3">
                    <div>
                      @if (item.dataType === 'users') {
                      <div>
                        @if (item?.name) { @if (!item?.isGroup) {
                        <ngx-avatars
                          size="40"
                          src="{{ item?.user_profile_image_url }}"
                          name="{{ item?.name }}"
                          [round]="true"
                          initialsSize="2"
                          class="flex-center"
                        ></ngx-avatars>
                        } @if (item?.isGroup) {
                        <div>
                          <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
                        </div>
                        } } @if (!item?.name) { @if (item?.user_first_middle_name && !item?.isGroup) {
                        <ngx-avatars
                          size="40"
                          src="{{ item?.user_profile_image_url }}"
                          name="{{ item?.user_first_middle_name + ' ' + item?.user_last_name }}"
                          [round]="true"
                          initialsSize="2"
                          class="flex-center"
                        ></ngx-avatars>
                        } @if (item?.first_middle_name && !item?.isGroup) {
                        <ngx-avatars
                          size="40"
                          src="{{ item?.profile_image_url }}"
                          name="{{ item?.first_middle_name + ' ' + item?.last_name }}"
                          [round]="true"
                          initialsSize="2"
                          class="flex-center"
                        ></ngx-avatars>
                        } @if (item?.isGroup) {
                        <div>
                          <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
                        </div>
                        } }
                      </div>
                      } @else if (item.dataType === 'template') {
                      <div>
                        @if(item.key_path){
                        <img class="back-avatar-grup rounded bg-[#f1f1f1] p-1" [src]="item.key_path" *ngIf="!item?.profile_image_url" />
                        }@else{
                        <img class="back-avatar-grup" src="assets/images/avtar-trust.svg" *ngIf="!item?.profile_image_url" />
                        }
                        <img class="back-avatar-grup" [src]="item?.profile_image_url" *ngIf="item?.profile_image_url" />
                      </div>
                      }
                    </div>

                    <div class="flex flex-col gap-[2px]">
                      @if (item.dataType === 'users') { @if (item?.user_first_middle_name && !item?.isGroup) {
                      <div class="app__form--attribute--title text-sm font-normal text-[#18191C]">
                        {{ item?.user_first_middle_name + ' ' + item?.user_last_name | capitalizeRomanNumerals }}
                      </div>
                      } @if (item?.user_first_middle_name && item?.isGroup) {
                      <div class="app__form--attribute--title text-sm font-normal text-[#18191C]">
                        {{ item?.user_first_middle_name + ' ' + item?.user_last_name | capitalizeRomanNumerals }}
                      </div>
                      } @if (item?.first_middle_name) {
                      <div class="app__form--attribute--title text-sm font-normal text-[#18191C]">
                        {{ item?.first_middle_name + ' ' + item?.last_name | capitalizeRomanNumerals }}
                      </div>
                      } @if (item?.name) {
                      <div class="app__form--attribute--title text-sm font-normal text-[#18191C]">
                        {{ item?.name | capitalizeRomanNumerals }}
                      </div>
                      } @if (item?.relationship_name && !item?.isGroup) {
                      <div class="text-[10px] leading-3 text-[#707070]">
                        {{ item?.relationship_name }}
                      </div>
                      } } @else if (item.dataType === 'template') {
                      <div class="text-sm font-normal font-sans color-[#18191C]">{{ item?.form_name }}</div>
                      <div class="text-[10px] leading-3 font-normal font-sans color-[#707070]">{{ item?.type }}</div>
                      }
                    </div>
                  </div>
                </div>
              </mat-option>
              }
            </div>
            } @if (isShowFooter) {
            <div class="footer-container p-4">
              <div [ngClass]="'grid grid-cols-' + templateConfigurationList.length + ' gap-3'">
                @for (action of templateConfigurationList; track action.id) {
                <mat-option class="footer-menu" (click)="handleUnifiedViewFooterAction(action)">
                  <div class="flex-center h-[40px] w-[40px]">
                    <img
                      class="h-full w-full"
                      [src]="
                        origin == 'location' || action.isCustomImg
                          ? action?.img
                          : action?.img
                          ? 'assets/images/discovery/' + action?.img + '.svg'
                          : 'assets/images/shared.svg'
                      "
                    />
                  </div>
                  <div class="template-text" appTooltip [toolTipText]="action?.displayType ? action?.displayType : action.label">
                    {{ action?.displayType ? action?.displayType : action.label }}
                  </div>
                </mat-option>
                }
              </div>
            </div>
            }
          </div>
          } @if (!unifiedView) {
          <mat-tab-group animationDuration="0ms" dynamicHeight (selectedTabChange)="onConfigurationChange($event)" *ngIf="isInputFocused">
            @for (item of filterConfiguration; track trackByFn($index, item)) {
            <mat-tab [label]="item.label">
              <ng-template matTabContent>
                <ng-container *ngIf="selectedConfiguration.key === USERS">
                  <div class="width-100per">
                    @if ((selectedConfiguration?.data | addFilterUserDataList :
                    selectedConfiguration.selectedData:connectionUserFormControl.value)?.length == 0) {
                    <mat-option class="h-fit">
                      <div class="flex gap-4 py-5 h-fit fl-al-center">
                        <div class="flex" style="height: 84px; width: 84px">
                          <img src="assets/images/no-matchin-result.svg" />
                        </div>
                        <div>
                          <div class="font-semibold text-[#18191C]" style="font-size: 22px; margin-bottom: 8px; line-height: 24px">
                            No matching results to show
                          </div>
                          <div class="text-sm font-normal text-[#18191C]">Try changing the search terms, or create a new user</div>
                        </div>
                      </div>
                    </mat-option>
                    }
                    <div class="search-box-container">
                      @if ( (selectedConfiguration?.data | addFilterUserDataList :
                      selectedConfiguration.selectedData:connectionUserFormControl.value)?.length !== 0) {
                      <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-2 px-4 pt-4 pb-3">
                        @for (user of selectedConfiguration.data | addFilterUserDataList :
                        selectedConfiguration.selectedData:connectionUserFormControl.value | slice:0:5 ; track user) {
                        <mat-option class="search-content-box option-mobile w-full min-w-0" (onSelectionChange)="selectUser(user)">
                          <div>
                            @if (user?.name) { @if (!user?.isGroup) {
                            <ngx-avatars
                              size="45"
                              src="{{ user?.user_profile_image_url }}"
                              name="{{ user?.name }}"
                              [round]="true"
                              initialsSize="2"
                              class="flex-center"
                            ></ngx-avatars>
                            } @if (user?.isGroup) {
                            <div>
                              <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
                            </div>
                            } } @if (!user?.name) { @if (user?.user_first_middle_name && !user?.isGroup) {
                            <ngx-avatars
                              size="45"
                              src="{{ user?.user_profile_image_url }}"
                              name="{{ user?.user_first_middle_name + ' ' + user?.user_last_name }}"
                              [round]="true"
                              initialsSize="2"
                              class="flex-center"
                            ></ngx-avatars>
                            } @if (user?.first_middle_name && !user?.isGroup) {
                            <ngx-avatars
                              size="45"
                              src="{{ user?.profile_image_url }}"
                              name="{{ user?.first_middle_name + ' ' + user?.last_name }}"
                              [round]="true"
                              initialsSize="2"
                              class="flex-center"
                            ></ngx-avatars>
                            } @if (user?.isGroup) {
                            <div>
                              <img class="back-avatar-grup" src="assets/images/round-group-name.svg " />
                            </div>
                            } }
                          </div>
                          <div class="txt-center">
                            @if (user?.user_first_middle_name && !user?.isGroup) {
                            <div class="user-text font-semibold">
                              {{ user?.user_first_middle_name + ' ' + user?.user_last_name | capitalizeRomanNumerals }}
                              <span>{{ user.relationship_name }}</span>
                            </div>
                            } @if (user?.user_first_middle_name && user?.isGroup) {
                            <div class="user-text font-semibold">
                              {{ user?.user_first_middle_name + ' ' + user?.user_last_name | capitalizeRomanNumerals }}
                            </div>
                            } @if (user?.first_middle_name) {
                            <div class="user-text font-semibold">
                              {{ user?.first_middle_name + ' ' + user?.last_name | capitalizeRomanNumerals }}
                              <span>{{ user?.relationship_name }}</span>
                            </div>
                            } @if (user?.name) {
                            <div class="user-text font-semibold">
                              {{ user?.name | capitalizeRomanNumerals }}
                            </div>
                            }
                          </div>
                        </mat-option>
                        }
                      </div>
                      } @if (isShowFooter) {
                      <div [ngClass]="{ 'grid grid-cols-2': isShowCreateNewUser, 'footer-container gap-3 p-4': true }">
                        @if (isShowCreateNewUser) {
                        <mat-option class="footer-menu" (click)="openInvite()">
                          <div class="flex-center">
                            <img height="h-[33px]" src="assets/images/footer-new-user.svg" />
                          </div>
                          <div class="flex-center template-text mt-1">{{ isManageGuardian ? 'Invite User' : 'Create New User' }}</div>
                        </mat-option>
                        }
                        <mat-option class="footer-menu" (click)="addExistingUsers()">
                          <div class="flex-center">
                            <img height="h-[33px]" src="assets/images/footer-global-search.svg" />
                          </div>
                          <div class="flex-center template-text mt-1">Global User Search</div>
                        </mat-option>
                      </div>
                      }
                    </div>
                  </div>
                  @if (loader) {
                  <mat-option class="h-fit">
                    <div class="search-box-container">
                      <div class="loader-container grid grid-cols-7 p-4 pb-0"></div>
                      <hr style="margin: 0px" />
                    </div>
                  </mat-option>
                  }
                </ng-container>
                <ng-container *ngIf="selectedConfiguration.key === TEMPLATE">
                  <div class="width-100per">
                    @if ((selectedConfiguration?.data | addFilterReportDataList :
                    selectedConfiguration.selectedData:connectionUserFormControl.value)?.length == 0) {
                    <mat-option class="h-fit">
                      <div class="flex gap-4 py-5 h-fit fl-al-center">
                        <div class="flex" style="height: 84px; width: 84px">
                          <img src="assets/images/no-matchin-result.svg" />
                        </div>
                        <div style="color: #18191c">
                          <div class="font-semibold text-[#18191C]" style="font-size: 22px; margin-bottom: 8px; line-height: 24px">
                            No matching results to show
                          </div>
                          <div class="text-sm font-normal text-[#18191C]">Try changing the search terms, or add a new template</div>
                        </div>
                      </div>
                    </mat-option>
                    } @if ( (selectedConfiguration?.data | addFilterReportDataList :
                    selectedConfiguration.selectedData:connectionUserFormControl.value)?.length !== 0) {
                    <div>
                      <div class="search-list-overflow">
                        <div>
                          <mat-option
                            class="search-list-box"
                            *ngFor="
                              let entity of selectedConfiguration.data
                                | addFilterReportDataList : selectedConfiguration.selectedData : connectionUserFormControl.value;
                              let i = index
                            "
                            (onSelectionChange)="selectConnectedUser(entity)"
                          >
                            <div class="d-flex fl-justify-between fl-al-center">
                              <div class="d-flex fl-al-center gap-3">
                                <div>
                                  @if(entity.key_path){
                                  <img class="back-avatar-grup rounded bg-[#f1f1f1] p-1" [src]="entity.key_path" *ngIf="!entity?.profile_image_url" />
                                  }@else{
                                  <img class="back-avatar-grup" src="assets/images/avtar-trust.svg" *ngIf="!entity?.profile_image_url" />

                                  }
                                  <img class="back-avatar-grup" src="{{ entity?.profile_image_url }}" *ngIf="entity?.profile_image_url" />
                                </div>

                                <div>
                                  <div class="text-sm font-normal font-sans color-[#18191C]">{{ entity?.form_name }}</div>
                                  <div class="text-[10px] leading-3 font-normal font-sans color-[#707070]">{{ entity?.type }}</div>
                                </div>
                              </div>
                            </div>
                          </mat-option>
                        </div>
                      </div>
                    </div>
                    } @if (isShowFooter) {
                    <div
                      [ngClass]="'grid-cols-' + selectedConfiguration.templateConfigurationList.length + ' grid gap-3'"
                      class="footer-container p-4"
                      *ngIf="selectedConfiguration.templateConfigurationList.length > 0"
                    >
                      <mat-option
                        class="footer-menu"
                        (click)="addNewTemplate(item)"
                        *ngFor="let item of selectedConfiguration.templateConfigurationList"
                      >
                        <div class="flex-center h-[40px] w-[40px]">
                          <img
                            class="h-full w-full"
                            [src]="
                              origin == 'location' || item.isCustomImg
                                ? item?.img
                                : item?.img
                                ? 'assets/images/discovery/' + item?.img + '.svg'
                                : 'assets/images/shared.svg'
                            "
                          />
                        </div>
                        <div class="template-text" appTooltip [toolTipText]="item?.displayType ? item?.displayType : item.label">
                          {{ item?.displayType ? item?.displayType : item.label }}
                        </div>
                      </mat-option>
                    </div>
                    }
                  </div>
                  @if (loader) {
                  <mat-option class="h-fit">
                    <div class="search-box-container">
                      <div class="loader-container grid grid-cols-7 p-4 pb-0">
                        <div class="width-100per" *ngFor="let item of loaderItems">
                          <div class="width-100per" id="{{ item.id }}">
                            <div class="ph-item width-100per content__loader" style="padding: 0px; margin: 0px; border: none">
                              <div class="ph-col-12" style="padding: 0px !important; margin: 0px">
                                <div class="ph-row">
                                  <div class="ph-col-12" style="height: 96px; border-radius: 4px; max-width: 100px"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <hr style="margin: 0px" />
                      <div class="loader-container grid grid-cols-3 p-4 gap-2 pb-0">
                        <div class="width-100per" *ngFor="let item of loaderItems | slice : 0 : 3">
                          <div class="width-100per" id="{{ item.id }}">
                            <div class="ph-item width-100per content__loader" style="padding: 0px; margin: 0px; border: none">
                              <div class="ph-col-12" style="padding: 0px !important; margin: 0px">
                                <div class="ph-row">
                                  <div class="ph-col-12" style="height: 94px; border-radius: 4px; max-width: 256px"></div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> </mat-option
                  >}
                </ng-container>
              </ng-template>
            </mat-tab>
            }
          </mat-tab-group>
          }
        </mat-autocomplete>
      </mat-form-field>
      }
    </div>
  </div>
</div>
